import React from "react";

function About() {
  return (
    <section id="about" className="my-12 bg-gray-50">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-gray-900">
          About Me
        </h2>
        <p className="mt-4 text-gray-700 text-center max-w-3xl mx-auto">
          I recently passed the BAR and am passionate about using my skills to
          advocate for fairness and equity. With a strong academic foundation
          and hands-on experience, I am dedicated to making a meaningful impact
          in the legal field.
        </p>
        <p className="mt-6 text-gray-700 text-center max-w-3xl mx-auto">
          Of course, beyond my professional achievements, I'm proud to hold the
          illustrious title of "second-best brother" (a role I humbly embrace).
          Being the runner-up has taught me the value of persistence, humor, and
          knowing when to laugh at myself—essential traits in both family
          debates and legal cases.
        </p>
        <p className="mt-4 text-gray-700 text-center max-w-3xl mx-auto">
          So whether it’s a courtroom or a family reunion, I bring dedication,
          wit, and an unshakable resolve to everything I do.
        </p>
      </div>
    </section>
  );
}

export default About;
